
import { Component, Vue } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import Empty from '@/components/Empty/index.vue'
import ImageUpload from '@/components/ImgUpload/index.vue'
import { UserModule } from '@/store/modules/user'
import {
  getCategoryList,
  deleCategory,
  editCategory,
  addCategory,
  enableOrDisableEmployee,
  categorySetSort
} from '@/api/category'
import { getDishPage } from '@/api/dish'
import SortInlineEdit from '@/components/SortInlineEdit/index.vue'

const CATEGORY_TREE_EXPAND_KEY = 'admin-category-tree-expanded'
const CATEGORY_TREE_SCROLL_KEY = 'admin-category-tree-scroll'

@Component({
  name: 'Category',
  components: {
    HeadLable,
    Empty,
    ImageUpload,
    SortInlineEdit
  }
})
export default class extends Vue {
  private actionType: string = ''
  private id = ''
  private status = ''
  private parentCategoryList: any[] = []
  private allCategoryList: any[] = []
  private parentNameMap: Record<string, string> = {}
  private name: string = ''
  private action: string = ''
  private tableData = []
  private type = ''
  private isSearch: boolean = false
  private restoringTree = false
  /** 本店商品，用于二级分类统计商品数 */
  private storeDishList: any[] = []
  private classData: any = {
    title: '添加商品分类',
    dialogVisible: false,
    categoryId: '',
    name: '',
    description: '',
    icon: '',
    iconEmoji: '',
    tag: '',
    sort: '',
    categoryLevel: 'root',
    parentId: null
  }

  get categoryIconImageUrl() {
    const icon = (this.classData.icon || '').trim()
    return this.isCategoryIconUrl(icon) ? icon : ''
  }

  get categoryIconUploadHint() {
    if (this.classData.categoryLevel === 'root') {
      return '最佳尺寸 680×400（约 1.7:1，首页分类卡片）；PNG/JPG，不超过 5M；重新上传会删除旧图'
    }
    if (this.classData.categoryLevel === 'brand') {
      return '最佳尺寸 128×128 方图（品牌/额度展示）；PNG/JPG，不超过 5M；重新上传会删除旧图'
    }
    return '最佳尺寸 128×128 方图（点餐侧栏约 48×48）；PNG/JPG，不超过 5M；重新上传会删除旧图'
  }

  get categoryLevelLabel() {
    const level = this.classData.categoryLevel
    if (level === 'root') return '一级分类'
    if (level === 'level2') return '二级分类'
    if (level === 'brand') return '品牌分类（三级）'
    return '分类'
  }

  get needsParent() {
    const level = this.classData.categoryLevel
    return level === 'level2' || level === 'brand'
  }

  get parentSelectPlaceholder() {
    if (this.classData.categoryLevel === 'brand') {
      return '请选择二级分类作为父分类'
    }
    if (this.classData.categoryLevel === 'level2') {
      return '请选择一级分类作为父分类'
    }
    return '请选择父分类'
  }

  private getCategoryIconPreview(row: any) {
    const raw = row && row.icon
    const icon = raw == null ? '' : String(raw).trim()
    return this.isCategoryIconUrl(icon) ? icon : ''
  }

  private isCategoryIconUrl(val: any) {
    if (val == null || val === '') return false
    const s = String(val)
    if (/^https?:\/\//i.test(s) || s.indexOf('//') === 0) return true
    return /^[a-zA-Z0-9][-a-zA-Z0-9.]*\.[a-zA-Z]{2,}(\/|$)/.test(s)
  }

  private resolveCategoryIconForSubmit() {
    const img = String(this.classData.icon || '').trim()
    if (this.isCategoryIconUrl(img)) return img
    const emoji = String(this.classData.iconEmoji || '').trim()
    return emoji || null
  }

  private syncCategoryIconFields(icon: any) {
    const v = icon == null ? '' : String(icon).trim()
    if (this.isCategoryIconUrl(v)) {
      this.classData.icon = v
      this.classData.iconEmoji = ''
    } else {
      this.classData.icon = ''
      this.classData.iconEmoji = v
    }
  }

  private onCategoryIconImageChange(url: string) {
    this.classData.icon = url || ''
    if (url) this.classData.iconEmoji = ''
    this.$nextTick(() => {
      if (this.$refs.classData) {
        this.$refs.classData.validateField('icon')
      }
    })
  }

  get parentOptionsForForm() {
    const t = Number(this.type) || 1
    let list = this.allCategoryList.filter(
      (item) => String(item.type) === String(t)
    )
    if (this.action === 'edit' && this.classData.id) {
      list = list.filter(
        (item) => String(item.id) !== String(this.classData.id)
      )
    }
    const level = this.classData.categoryLevel
    if (level === 'level2') {
      // 二级：父级只能是一级
      list = list.filter((c) => this.getCategoryDepth(c) === 1)
    } else if (level === 'brand') {
      // 品牌（三级）：父级只能是二级
      list = list.filter((c) => this.getCategoryDepth(c) === 2)
    } else {
      list = []
    }
    return list
      .map((item: any) => ({
        id: item.id,
        label: this.buildCategoryPath(item.id)
      }))
      .sort((a, b) => a.label.localeCompare(b.label, 'zh-CN'))
  }

  private getCategoryParentId(item: any) {
    if (!item) return null
    const p = item.parentId != null ? item.parentId : item.parent_id
    if (p == null || p === '' || Number(p) === 0) return null
    return Number(p)
  }

  private buildCategoryPath(categoryId: number | string) {
    const map: Record<string, any> = {}
    this.allCategoryList.forEach((c: any) => {
      if (c && c.id != null) map[String(c.id)] = c
    })
    const parts: string[] = []
    let cur = map[String(categoryId)]
    let guard = 0
    while (cur && guard < 8) {
      parts.unshift(cur.name)
      const pid = this.getCategoryParentId(cur)
      cur = pid != null ? map[String(pid)] : null
      guard++
    }
    return parts.join(' / ') || String(categoryId)
  }

  get rules() {
    return {
      name: [
        {
          required: true,
          trigger: 'blur',
          validator: (rule: any, value: string, callback: Function) => {
            if (!value || !String(value).trim()) {
              callback(new Error('分类名称不能为空'))
            } else {
              callback()
            }
          }
        }
      ],
      icon: [
        {
          trigger: 'change',
          validator: (rule: any, value: string, callback: Function) => {
            if (this.classData.categoryLevel !== 'root') {
              callback()
              return
            }
            if (!this.isCategoryIconUrl(value)) {
              callback(new Error('请上传图标'))
            } else {
              callback()
            }
          }
        }
      ],
      sort: [
        {
          required: false,
          trigger: 'blur',
          validator: (rule: any, value: string, callback: Function) => {
            if (value === '' || value === null || value === undefined) {
              callback()
              return
            }
            const reg = /^\d+$/
            if (!reg.test(String(value))) {
              callback(new Error('排序只能输入数字类型'))
            } else if (Number(value) > 99) {
              callback(new Error('排序只能输入0-99数字'))
            } else {
              callback()
            }
          }
        }
      ]
    }
  }

  created() {
    this.loadParentCategoryList()
    this.init()
  }

  activated() {
    this.$nextTick(() => this.restoreTreeUiState())
  }

  private isRootCategory(row: any) {
    const pid = row && (row.parentId != null ? row.parentId : row.parent_id)
    return pid == null || pid === '' || Number(pid) === 0
  }

  private getCategoryDepth(row: any) {
    if (!row) return 1
    let depth = 1
    let pid = this.getCategoryParentId(row)
    const map: Record<string, any> = {}
    this.allCategoryList.forEach((c: any) => {
      if (c && c.id != null) map[String(c.id)] = c
    })
    let guard = 0
    while (pid != null && map[String(pid)] && guard < 8) {
      depth++
      pid = this.getCategoryParentId(map[String(pid)])
      guard++
    }
    return depth
  }

  private getLevelLabel(row: any) {
    const d = this.getCategoryDepth(row)
    if (d <= 1) return '一级'
    if (d === 2) return '二级'
    if (d === 3) return '品牌'
    return `${d}级`
  }

  private async loadParentCategoryList() {
    try {
      const storeId = UserModule.storeId
      if (!storeId) return
      const [rootRes, allRes] = await Promise.all([
        getCategoryList({ onlyRoot: true, storeId }),
        getCategoryList({ storeId })
      ])
      if (String(rootRes.data.code) === '1') {
        this.parentCategoryList = rootRes.data.data || []
      }
      if (String(allRes.data.code) === '1') {
        this.allCategoryList = allRes.data.data || []
        const map: Record<string, string> = {}
        this.allCategoryList.forEach((item: any) => {
          map[String(item.id)] = item.name
        })
        this.parentNameMap = map
      }
    } catch (e) {
      console.log(e)
    }
  }

  /** 某分类及其所有子孙 id */
  private collectDescendantIds(categoryId: any): Set<string> {
    const ids = new Set<string>()
    if (categoryId == null || categoryId === '') return ids
    const root = String(categoryId)
    ids.add(root)
    const childrenOf = (pid: string) => {
      ;(this.allCategoryList || []).forEach((c: any) => {
        if (!c || c.id == null) return
        if (String(this.getCategoryParentId(c)) === pid) {
          const cid = String(c.id)
          if (!ids.has(cid)) {
            ids.add(cid)
            childrenOf(cid)
          }
        }
      })
    }
    childrenOf(root)
    return ids
  }

  /** 商品是否挂在指定二级分类下（展示分类 / 品牌分类落在该二级或其三级子孙） */
  private dishBelongsToLevel2(dish: any, level2Id: any): boolean {
    if (!dish || level2Id == null) return false
    const scope = this.collectDescendantIds(level2Id)
    const pushCheck = (raw: any) => {
      if (raw == null || raw === '') return false
      return scope.has(String(raw))
    }
    if (Array.isArray(dish.displayCategoryIds)) {
      for (const id of dish.displayCategoryIds) {
        if (pushCheck(id)) return true
      }
    }
    if (pushCheck(dish.categoryId)) return true
    return false
  }

  private countDishesUnderLevel2(level2Id: any): number {
    let n = 0
    ;(this.storeDishList || []).forEach((d: any) => {
      if (this.dishBelongsToLevel2(d, level2Id)) n += 1
    })
    return n
  }

  /** 一级显示二级个数；二级显示商品个数 */
  private attachCategoryDisplayCounts(roots: any[]) {
    ;(roots || []).forEach((l1: any) => {
      if (!l1) return
      const l2List = Array.isArray(l1.children) ? l1.children : []
      l1.displayCount = l2List.length
      l2List.forEach((l2: any) => {
        if (!l2) return
        l2.displayCount = this.countDishesUnderLevel2(l2.id)
        // 列表不再展示三级，二级下不挂分类子节点
        delete l2.children
      })
      if (!l2List.length) {
        delete l1.children
      }
    })
  }

  /** 扁平列表 → 树（仅一级 / 二级，不展示三级品牌） */
  private buildCategoryTree(list: any[]) {
    const nodes: Record<string, any> = {}
    ;(list || []).forEach((item: any) => {
      if (!item || item.id == null) return
      // 深度按完整分类表计算，三级及以下不进展示树
      if (this.getCategoryDepth(item) >= 3) return
      nodes[String(item.id)] = { ...item, children: [] as any[] }
    })
    const roots: any[] = []
    Object.keys(nodes).forEach(key => {
      const node = nodes[key]
      const pid = this.getCategoryParentId(node)
      if (pid != null && nodes[String(pid)]) {
        nodes[String(pid)].children.push(node)
      } else {
        roots.push(node)
      }
    })
    const sortAndClean = (arr: any[]) => {
      arr.sort((a, b) => {
        const sa = Number(a.sort != null ? a.sort : 0)
        const sb = Number(b.sort != null ? b.sort : 0)
        if (sa !== sb) return sa - sb
        return Number(a.id) - Number(b.id)
      })
      arr.forEach(n => {
        if (n.children && n.children.length) {
          sortAndClean(n.children)
        } else {
          delete n.children
        }
      })
    }
    sortAndClean(roots)
    this.attachCategoryDisplayCounts(roots)
    return roots
  }

  /** 名称搜索时保留命中节点及其祖先、子孙 */
  private filterCategoryFlatByName(list: any[], keyword: string) {
    const key = (keyword || '').trim()
    if (!key) return list || []
    const map: Record<string, any> = {}
    ;(list || []).forEach((c: any) => {
      if (c && c.id != null) map[String(c.id)] = c
    })
    const keep = new Set<string>()
    const addAncestors = (id: any) => {
      let cur = map[String(id)]
      let guard = 0
      while (cur && guard < 8) {
        keep.add(String(cur.id))
        const pid = this.getCategoryParentId(cur)
        if (pid == null) break
        cur = map[String(pid)]
        guard++
      }
    }
    const addDescendants = (id: any) => {
      keep.add(String(id))
      ;(list || []).forEach((c: any) => {
        if (c && String(this.getCategoryParentId(c)) === String(id)) {
          addDescendants(c.id)
        }
      })
    }
    ;(list || []).forEach((c: any) => {
      if (c && c.name && String(c.name).indexOf(key) !== -1) {
        addAncestors(c.id)
        addDescendants(c.id)
      }
    })
    return (list || []).filter((c: any) => c && keep.has(String(c.id)))
  }

  private setSortHandle(row: any, sort: number) {
    if (!row || !row.id) return
    categorySetSort({ id: row.id, sort })
      .then((res: any) => {
        if (res && res.data && String(res.data.code) === '1') {
          this.$message.success('排序已更新')
          this.init()
        } else {
          this.$message.error((res.data && (res.data.msg || res.data.desc)) || '排序失败')
        }
      })
      .catch((err: any) => {
        this.$message.error('请求出错了：' + ((err && err.message) || '未知错误'))
      })
  }

  // 初始化：树形仅展示一、二级；名称后带数量
  private async init(isSearch?) {
    this.isSearch = !!isSearch
    const storeId = UserModule.storeId
    if (!storeId) {
      this.tableData = []
      this.storeDishList = []
      return
    }
    try {
      const params: any = { storeId, type: 1 }
      const [res, dishRes] = await Promise.all([
        getCategoryList(params),
        getDishPage({ page: 1, pageSize: 5000, storeId })
      ])
      if (String(res.data.code) !== '1') {
        this.$message.error(res.data.desc || res.data.msg || '查询失败')
        return
      }
      let list = res.data.data || []
      this.allCategoryList = list
      if (dishRes && String(dishRes.data.code) === '1') {
        this.storeDishList =
          (dishRes.data.data && dishRes.data.data.records) || []
      } else {
        this.storeDishList = []
      }
      const nameMap: Record<string, string> = {}
      list.forEach((item: any) => {
        if (item && item.id != null) nameMap[String(item.id)] = item.name
      })
      this.parentNameMap = nameMap
      this.parentCategoryList = list.filter((c: any) => this.isRootCategory(c))
      if (this.name) {
        list = this.filterCategoryFlatByName(list, this.name)
      }
      this.tableData = this.buildCategoryTree(list)
      this.restoreTreeUiState()
    } catch (err: any) {
      if (err && (err.message === '重复请求' || err.__CANCEL__)) return
      console.log(err, 'err')
      this.$message.error('请求出错了：' + ((err && err.message) || '未知错误'))
    }
  }

  private readExpandedKeys(): string[] {
    try {
      const raw = sessionStorage.getItem(CATEGORY_TREE_EXPAND_KEY)
      const arr = raw ? JSON.parse(raw) : []
      return Array.isArray(arr) ? arr.map(String) : []
    } catch (_) {
      return []
    }
  }

  private writeExpandedKeys(keys: string[]) {
    sessionStorage.setItem(CATEGORY_TREE_EXPAND_KEY, JSON.stringify(keys || []))
  }

  private persistTreeUiState() {
    try {
      const wrap =
        this.$el && (this.$el as HTMLElement).querySelector('.el-table__body-wrapper')
      if (wrap) {
        sessionStorage.setItem(
          CATEGORY_TREE_SCROLL_KEY,
          String((wrap as HTMLElement).scrollTop || 0)
        )
      }
    } catch (_) {
      /* ignore */
    }
  }

  private handleExpandChange(row: any, expanded: any) {
    if (this.restoringTree) return
    if (!row || row.id == null) return
    const isExpanded =
      typeof expanded === 'boolean'
        ? expanded
        : Array.isArray(expanded) && expanded.indexOf(row) > -1
    const set = new Set(this.readExpandedKeys())
    const key = String(row.id)
    if (isExpanded) {
      set.add(key)
    } else {
      set.delete(key)
    }
    this.writeExpandedKeys(Array.from(set))
  }

  /** 确保某分类及其祖先都处于展开记录中 */
  private ensureCategoryPathExpanded(categoryId: any) {
    if (categoryId == null || categoryId === '') return
    const map: Record<string, any> = {}
    this.allCategoryList.forEach((c: any) => {
      if (c && c.id != null) map[String(c.id)] = c
    })
    const set = new Set(this.readExpandedKeys())
    let cur = map[String(categoryId)]
    let guard = 0
    while (cur && cur.id != null && guard < 8) {
      set.add(String(cur.id))
      const pid = this.getCategoryParentId(cur)
      cur = pid != null ? map[String(pid)] : null
      guard++
    }
    this.writeExpandedKeys(Array.from(set))
  }

  private restoreTreeUiState() {
    const keys = this.readExpandedKeys()
    const scrollTop = Number(sessionStorage.getItem(CATEGORY_TREE_SCROLL_KEY) || 0)
    this.$nextTick(() => {
      const table: any = this.$refs.categoryTable
      if (!table || typeof table.toggleRowExpansion !== 'function') return
      this.restoringTree = true
      const keySet = new Set(keys)
      const expand = (list: any[]) => {
        ;(list || []).forEach((row: any) => {
          if (row && row.id != null && keySet.has(String(row.id))) {
            table.toggleRowExpansion(row, true)
          }
          if (row && row.children && row.children.length) {
            expand(row.children)
          }
        })
      }
      expand(this.tableData)
      this.$nextTick(() => {
        this.restoringTree = false
        try {
          const wrap =
            this.$el &&
            (this.$el as HTMLElement).querySelector('.el-table__body-wrapper')
          if (wrap && scrollTop > 0) {
            ;(wrap as HTMLElement).scrollTop = scrollTop
          }
        } catch (_) {
          /* ignore */
        }
      })
    })
  }

  private onCategoryLevelChange() {
    if (this.classData.categoryLevel === 'root') {
      this.classData.parentId = null
    } else {
      this.classData.parentId = null
    }
  }

  // 添加：root | level2 | brand
  private addClass(st: any, level: string = 'root') {
    this.persistTreeUiState()
    if (st == 'class') {
      if (level === 'level2') {
        this.classData.title = '新增二级分类'
      } else if (level === 'brand') {
        this.classData.title = '新增品牌分类'
      } else {
        this.classData.title = '新增一级分类'
        level = 'root'
      }
      this.type = '1'
    } else {
      this.classData.title = '新增套餐分类'
      this.type = '2'
      level = 'root'
    }
    this.action = 'add'
    this.classData.name = ''
    this.classData.description = ''
    this.classData.icon = ''
    this.classData.iconEmoji = ''
    this.classData.tag = ''
    this.classData.sort = ''
    this.classData.categoryLevel = level
    this.classData.parentId = null
    this.classData.dialogVisible = true
    this.actionType = 'add'
    this.$nextTick(() => {
      if (this.$refs.classData) {
        this.$refs.classData.clearValidate()
      }
    })
  }

  // 修改
  private editHandle(dat: any) {
    this.persistTreeUiState()
    this.ensureCategoryPathExpanded(dat && dat.id)
    this.classData.title = '修改分类'
    this.action = 'edit'
    this.type = String(dat.type)
    this.classData.name = dat.name
    this.classData.description = dat.description || ''
    this.syncCategoryIconFields(dat.icon || '')
    this.classData.tag = dat.tag || ''
    this.classData.sort = dat.sort
    this.classData.id = dat.id
    const pid = dat.parentId != null ? dat.parentId : dat.parent_id
    const hasParent = pid != null && pid !== '' && Number(pid) !== 0
    this.classData.parentId = hasParent ? Number(pid) : null
    const depth = this.getCategoryDepth(dat)
    if (depth <= 1) {
      this.classData.categoryLevel = 'root'
    } else if (depth === 2) {
      this.classData.categoryLevel = 'level2'
    } else {
      this.classData.categoryLevel = 'brand'
    }
    this.classData.dialogVisible = true
    this.actionType = 'edit'
    this.$nextTick(() => {
      if (this.$refs.classData) {
        this.$refs.classData.clearValidate()
      }
    })
  }

  /** 关闭弹窗（确定/取消共用） */
  private closeDialog() {
    this.classData.dialogVisible = false
  }

  // 关闭弹窗（右上角 X / 遮罩）；必须调用 done 才会真正关闭
  private handleClose(done: () => void) {
    this.classData.dialogVisible = false
    if (typeof done === 'function') {
      done()
    }
  }

  private onDialogClosed() {
    if (this.$refs.classData) {
      try {
        this.$refs.classData.clearValidate()
        this.$refs.classData.resetFields()
      } catch (e) {
        console.warn('reset category form failed', e)
      }
    }
    this.classData.name = ''
    this.classData.description = ''
    this.classData.icon = ''
    this.classData.iconEmoji = ''
    this.classData.tag = ''
    this.classData.sort = ''
    this.classData.parentId = null
  }

  //状态修改
  private statusHandle(row: any) {
    this.persistTreeUiState()
    this.id = row.id
    this.status = row.status
    this.$confirm('确认调整该分类的状态?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'customClass'
    }).then(() => {
      enableOrDisableEmployee({ id: this.id, status: !this.status ? 1 : 0 })
        .then(res => {
          const body = res.data || {}
          if (String(body.code) === '1') {
            this.$message.success('分类状态更改成功！')
            this.init()
          } else {
            this.$message.error(body.msg || '分类状态更改失败')
          }
        })
        .catch(err => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }

  //删除
  private deleteHandle(id: any) {
    this.persistTreeUiState()
    this.$confirm('此操作将永久删除该分类，是否继续？', '确定删除', {
      confirmButtonText: '删除',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      deleCategory(id)
        .then(res => {
          if (res.data.code === 1) {
            this.$message.success('删除成功！')
            this.init()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }

  $refs!: {
    classData: any
    categoryTable: any
  }

  //数据提交
  submitForm(st: any) {
    if (this.action === 'add') {
      this.$refs.classData.validate((value: boolean) => {
        if (value) {
          const parentId = this.resolveSubmitParentId()
          if (parentId === false) return
          // 继续添加时先记住层级/父分类，避免关窗重置后丢失
          const keepLevel = this.classData.categoryLevel
          const keepParentId = this.classData.parentId
          const keepTitle = this.classData.title
          addCategory({
            name: this.classData.name,
            description: this.classData.description || null,
            icon: this.resolveCategoryIconForSubmit(),
            tag: this.classData.tag || null,
            type: this.type,
            sort: this.resolveSubmitSort(),
            parentId: parentId || null
          })
            .then(res => {
              if (String(res.data && res.data.code) === '1') {
                this.$message.success('分类添加成功！')
                this.persistTreeUiState()
                if (parentId) {
                  this.ensureCategoryPathExpanded(parentId)
                }
                if (!st) {
                  this.closeDialog()
                } else {
                  this.classData.name = ''
                  this.classData.description = ''
                  this.classData.sort = ''
                  this.classData.icon = ''
                  this.classData.iconEmoji = ''
                  this.classData.tag = ''
                  this.classData.categoryLevel = keepLevel
                  this.classData.parentId = keepParentId
                  this.classData.title = keepTitle
                  this.$nextTick(() => {
                    if (this.$refs.classData) {
                      this.$refs.classData.clearValidate()
                    }
                  })
                }
                this.loadParentCategoryList()
                this.init()
              } else {
                this.$message.error((res.data && (res.data.desc || res.data.msg)) || '添加失败')
              }
            })
            .catch(err => {
              if (err && (err.message === '重复请求' || err.__CANCEL__)) return
              this.$message.error('请求出错了：' + ((err && err.message) || '未知错误'))
            })
        }
      })
    } else {
      this.$refs.classData.validate((value: boolean) => {
        if (value) {
          const parentId = this.resolveSubmitParentId()
          if (parentId === false) return
          editCategory({
            id: this.classData.id,
            name: this.classData.name,
            description: this.classData.description || null,
            icon: this.resolveCategoryIconForSubmit(),
            tag: this.classData.tag || null,
            sort: this.resolveSubmitSort(),
            type: this.type,
            parentId: parentId || null
          })
            .then(res => {
              if (String(res.data && res.data.code) === '1') {
                this.$message.success('分类修改成功！')
                this.persistTreeUiState()
                this.ensureCategoryPathExpanded(this.classData.id)
                this.closeDialog()
                this.loadParentCategoryList()
                this.init()
              } else {
                this.$message.error((res.data && (res.data.desc || res.data.msg)) || '修改失败')
              }
            })
            .catch(err => {
              if (err && (err.message === '重复请求' || err.__CANCEL__)) return
              this.$message.error('请求出错了：' + ((err && err.message) || '未知错误'))
            })
        }
      })
    }
  }

  /** 排序选填：新增空/0 由后端按同级 max+1；修改时保留填写值 */
  private resolveSubmitSort(): number | null {
    if (this.action === 'add') {
      const v = this.classData.sort
      if (v === '' || v === null || v === undefined) return null
      const n = Number(v)
      if (!Number.isFinite(n) || n <= 0) return null
      return n
    }
    const v = this.classData.sort
    if (v === '' || v === null || v === undefined) return 0
    const n = Number(v)
    return Number.isFinite(n) ? n : 0
  }

  /** 解析提交用的 parentId；校验失败返回 false */
  private resolveSubmitParentId(): number | null | false {
    const level = this.classData.categoryLevel
    if (level === 'root') {
      return null
    }
    const parentId = this.classData.parentId
    if (parentId == null || parentId === '') {
      this.$message.error(
        level === 'brand' ? '请选择二级分类作为父分类' : '请选择一级分类作为父分类'
      )
      return false
    }
    const parent = this.allCategoryList.find(
      (c: any) => c && String(c.id) === String(parentId)
    )
    if (!parent) {
      this.$message.error('父分类不存在，请重新选择')
      return false
    }
    const depth = this.getCategoryDepth(parent)
    if (level === 'level2' && depth !== 1) {
      this.$message.error('二级分类的父分类必须是一级分类')
      return false
    }
    if (level === 'brand' && depth !== 2) {
      this.$message.error('品牌分类的父分类必须是二级分类')
      return false
    }
    return Number(parentId)
  }
}
